import React, { Suspense } from 'react';
import { CalendarViewsProvider } from './view/calendarViewsProvider';
import { useIsMobile } from '../../../util/utils';
import { Box } from '@mui/system';

// Dynamically import the WeekNavigation components for desktop and mobile
const KeteroCalendarControllerDesktop = React.lazy(() => import('./keteroCalendarController_desktop')); // Desktop version
const KeteroCalendarControllerMobile = React.lazy(() => import('./keteroCalendarController_mobile'));   // Mobile version

const KeteroCalendarController = () => { 
  const isMobile = useIsMobile();
  return (
    <CalendarViewsProvider>
      <Box>
      <Suspense fallback={<div>Loading...</div>}>
        {/* Conditionally render the mobile or desktop version based on screen size */}
        {isMobile ? <KeteroCalendarControllerMobile /> : <KeteroCalendarControllerDesktop />}
      </Suspense>
      </Box>
    </CalendarViewsProvider>
  );
};

export default KeteroCalendarController;
